exports.default = {
  'scroll_options_left': '向左滑动查看更多选项',
  'scroll_options_right': '向右滑动查看更多选项',
  'context_cleared': '上下文已清除',
  'select_all': '全选',
  'cancel': '取消',
  'generate_share_link': '生成分享链接',
  'share_link_dialog_title': '分享链接已生成',
  'share_link_dialog_description': '请点击“复制链接”将分享链接复制到剪贴板。',
  'copy_share_link': '复制链接',
  'add_to_project': '保存到项目',
  'this_agent_has_been_deleted': '此智能体已删除！',
  'this_agent_has_been_removed': '此智能体已下架！',
  'please_enter_your_question_or_requirement': '发送消息...',
  'single_image_size_no_more_than_50M': '单张图片大小不超过20M，最多同时上传10张图片。',
  'reference_image_upload_hint': '单张图片大小不超过 20MB，当前模型最多上传 {count} 张参考图。',
  'hello': '你好',
  'no_recommended_questions': '没有推荐问题',
  'loading_recommended_questions': '加载推荐问题：',
  'append_continue_answer': '追加继续作答',
  'max_turns_stop_title': '执行已暂停',
  'max_turns_stop_description': '已达到本轮最大执行步数，当前进度已保存。是否继续完成剩余任务？',
  'max_turns_continue': '继续生成',
  'max_turns_later': '稍后再说',
  'max_turns_continue_message': '继续',
  'max_turns_stop_toast': '已达到本轮最大执行步数，进度保存后可继续对话',

  'video_script_tools': {
    'loading': '正在加载脚本…',
    'directory_empty': '当前会话暂无已保存的视频脚本',
    'content_empty': '暂无脚本正文',
    'failed': '脚本工具执行失败，请稍后重试。',
    'stopped': '脚本操作已停止',
    'more': '还有更多脚本，可继续查询。',
    'revision': '第 {revision} 版',
    'synced': '已同步',
    'syncing': '同步中',
    'sync_failed': '同步失败',
    'sync_unknown': '同步状态未知',
  },
  'video_script_preview': {
    'title': '视频脚本预览',
    'untitled': '未命名脚本',
    'status_writing': '编写中',
    'status_saving': '保存中',
    'status_syncing': '同步中',
    'save_success_requote': '脚本已更新，请重新报价',
    'status_saved': '已保存',
    'status_error': '保存失败',
    'error': '脚本保存失败',
    'edit': '编辑',
    'document': '文档',
    'copy': '复制全文',
    'download': '下载',
    'copy_success': '已复制全文',
    'loading': '加载中',
    'save': '保存新版本',
    'cancel': '取消',
    'content_placeholder': '使用 Markdown 编辑视频脚本',
    'content_required': '请输入脚本正文',
    'retry': '重新加载',
    'load_failed': '脚本读取失败',
    'save_failed': '脚本保存失败，请稍后重试。当前编辑内容已保留。',
    'save_auth_failed': '暂时无法保存，编辑内容已保留。请稍后重试。',
    'save_revision_conflict': '脚本已有新版本，无法覆盖保存。当前编辑内容已保留，请基于最新版本重新编辑。',
    'save_pending': '脚本正在同步或保存中，请稍后重试。当前编辑内容已保留。',
  },
  'failed_to_load_chat_records': '加载聊天记录失败：',
  'error': '报错了',
  'clear_failed_please_try_again_later': '清除失败，请稍后重试',
  'operation_failed_please_try_again_later': '操作失败，请稍后重试',
  'current_agent_does_not_support_image_function': '当前智能体不支持图片功能',
  'unsupported_image_format': '不支持的图片格式:',
  'upload_image_cannot_be_larger_than_50M': '上传图片不能大于20M',
  'files_current_selected_file_count': '个文件，当前选择文件数量',
  'upload_avatar_image_can_only_be_JPG_PNG_GIF_WEBP_format': '上传头像图片只能是JPG、PNG、GIF、WEBP格式!',
  'upload_image_size_cannot_exceed_50M': '上传图片大小不能超过20M!',
  'upload_failed': '上传失败',
  'image_index_label': '图{index}',
  'image_saved_successfully': '图片保存成功',
  'failed_to_save_image': '保存图片失败:',
  'image_save_failed': '图片保存失败',
  'loading_image': '正在加载图片',
  'network_error': '网络错误，发送失败。',
  'copy': '复制',
  'share': '分享',
  'save_note': '保存笔记',
  'copy_success': '复制成功',
  'copy_failed': '复制失败，请稍后重试！',
  'timeout_retry': '回答超时请稍后重试。',
  'regenerate': '重新生成',
  'cancel_like': '取消赞',
  'good_answer': '答的不错',
  'cancel_dislike': '取消踩',
  'not_good_enough': '还不够好',
  'close': '关闭',
  'submit': '提交',
  'dislike_reasons': {
    'not_good_enough': '还不够好',
    'irrelevant': '与问题无关',
    'inaccurate': '内容不准确',
    'misinformation': '有不实信息',
    'misleading_values': '错误的价值观导向',
    'prejudice': '存在偏见歧视',
    'violates_rights': '侵犯他人权益',
    'other_feedback': '我要吐槽'
  },
  'select_dislike_reason': '请选择您要点踩的内容~~',
  'document_name': '文档名称',
  'enter_document_name': '请输入文档名称',
  'search_project': '搜索项目',
  'add_as_subdocument': '添加为子文档',
  'add_as_subwebdocument': '添加为子网页',
  'unnamed_document': '未命名文档',
  'add_success': '添加成功',
  'get_recent_list_failed': '获取最近访问列表失败',
  'select_target_document': '选择目标文档',
  'insert_current_document': '插入当前文档',
  'agent_deleted': '此智能体已删除！',
  'agent_taken_down': '此智能体已下架！',
  'enter_to_send': '发送消息...',
  'file_limit_error': '每次最多选择{multiLimit}个文件，当前选择文件数量{filesLength}',
  'verification_failed': '验证失败',
  'loading': '加载中',
  'no_more': '没有更多了',
  'operation_failed': '操作失败，请稍后重试',
  'load_chat_history_failed': '加载聊天记录失败：{message}',
  'clear_success': '清除成功',
  'clear_failed': '清除失败，请稍后重试',
  'quota_exceeded': '额度超限',
  'content_violation': '内容违规',
  'unavailabled_agent': '当前智能体使用的模型已不在可用，请更新模型设置后继续对话',
  'click_to_update_model': '点击更新模型',
  'input_length_exceeded': '输入长度超出限制',
  'point_not_enough': '积分不足，请充值后继续对话',
  'thinking': '思考中...',
  'processing_thinking': '正在思考...',
  'processing_summarizing': '正在整理对话上下文 …',
  'thinking_error': '思考遇到问题',
  'thinking_start': '开始思考',
  'thinking_end': '思考完成',
  'chat_system_is_busy': '系统繁忙，正在为您重新回答',
  'system_is_busy': '系统繁忙',
  'go_back': '后退',
  'go': '前进',
  'refresh': '刷新',
  'full_screen': '全屏',
  'new_link_open': '新标签页面打开',
  'preview': '预览',
  'code': '代码',
  'edit': '编辑',
  'mobile_view': '移动视图',
  'desktop_view': '桌面视图',
  'code_download': '下载代码',
  'view_version_list': '查看版本列表',
  'version_history': '版本历史',
  'version': '版本: {version_number}',
  'generate_on': '生成于 {date}',
  'current_version': '当前',
  'version_switched': '已切换到所选版本',
  'no_version_download': '暂无可下载的版本',
  'download_start': '已开始下载项目',
  'version_loading': '加载中..',
  'version_empty': '暂无版本',
  'version_nomore': '没有更多了',
  'version_status_ready': '可运行',
  'version_status_fail': '失败',
  'version_status_building': '构建中',
  'open_web_editor': '预览网页',
  'no_version_preview': '暂无可预览的网页版本',
  'close_web_mode': '关闭web模式',
  'web_build_error': '此版本未能成功生成，无法预览。',
  'web_build_error_pls_fix': '项目构建错误，是否修复？',
  'web_error_fix': '修复',
  'repair_in_progress': '请稍候，我们正在修复您的页面',
  'file_directory': '目录结构',
  'choose_file_to_view': '选择一个文件进行查看',
  'selectFile': '从左侧文件树中选择一个文件来查看代码',
  'maxSize': '最大 5MB,支持常见图片格式',
  'uploadImage': '拖放或粘贴图片到此处，或点击上传',
  'text': '文本',
  'no_text_content': '无文本内容',
  'edit_text': '编辑文本',
  'link': '链接',
  'edit_link': '编辑链接',
  'add_link': '添加链接',
  'image': '图片',
  'chat': '对话',
  'apply': '应用',
  'replace': '替换',
  'replace_image': '替换图片',
  'upload': '上传',
  'confirm_crop': '确认裁剪',
  'crop_ratio_auto': '自适应',
  'crop_ratio_free': '自由',
  'crop_ratio_original': '原图比例',
  'send': '发送',
  'no_available_chat_mode': '暂无可用聊天模式',
  'web_search': '网页搜索',
  'web_search_description': '搜索互联网以获取最新信息',
  'external_skill_entry': '技能',
  'external_skill_catalog': '全部技能',
  'external_skill_recent_used': '最近使用',
  'external_skill_recent_empty': '暂无使用记录，使用技能后将显示在这里',
  'external_skill_catalog_desc': '选择适用于当前智能体类型的自定义技能，快速带入描述',
  'external_skill_refresh': '刷新',
  'external_skill_loading': '技能加载中...',
  'external_skill_empty': '当前智能体类型暂无可用自定义技能',
  'external_skill_empty_presets': '暂无可用预设',
  'external_skill_all': '全部',
  'external_skill_catalog_suffix': '技能',
  'external_skill_categories': '技能分类',
  'external_skill_search': '搜索技能',
  'external_skill_uncategorized': '其他技能',
  'external_skill_preset': '技能预设',
  'external_skill_preview': '描述预览',
  'external_skill_preview_action': '预览描述',
  'external_skill_insert': '带入输入框',
  'external_skill_insert_description': '带入到描述',
  'external_skill_generate': '生成',
  'external_skill_back': '返回全部技能',
  'external_skill_examples': '技能案例',
  'external_skill_example_image': '案例图片 {number}',
  'external_skill_example_video': '案例视频 {number}',
  'external_skill_examples_empty': '暂无图片或视频案例',
  'external_skill_example_loading': '正在加载案例…',
  'external_skill_example_failed': '案例加载失败',
  'external_skill_example_headphones': '耳机商品示例图',
  'external_skill_example_watch': '腕表商品示例图',
  'external_skill_example_camera': '相机商品示例图',
  'external_skill_example_perfume': '香水商品示例图',
  'external_skill_no_fields': '此预设无需额外设置',
  'external_skill_load_failed': '技能加载失败，请稍后重试',
  'external_skill_detail_failed': '预设详情加载失败',
  'external_skill_preview_failed': '描述预览失败，请稍后重试',
  'external_skill_upload_image': '上传图片',
  'external_skill_upload_file': '上传文件',
  'external_skill_upload_too_large': '文件大小超出限制',
  'external_skill_upload_image_only': '请选择图片文件',
  'external_skill_upload_type_not_allowed': '文件类型不符合预设要求',
  'external_skill_upload_failed': '上传失败，请稍后重试',
  'external_skill_upload_limit': '已达到上传数量限制',
  'external_skill_field_required': '必填',
  'external_skill_field_number': '请输入有效数值',
  'external_skill_field_min': '最小值 {min}',
  'external_skill_field_max': '最大值 {max}',
  'external_skill_field_step': '步长 {step}',
  'external_skill_field_step_from': '从 {min} 起，步长 {step}',
  'external_skill_field_precision': '最多 {precision} 位小数',
  'external_skill_field_min_length': '至少输入 {min} 个字符',
  'external_skill_field_max_length': '最多输入 {max} 个字符',
  'external_skill_field_max_count': '最多选择 {count} 项',
  'external_skill_field_option': '请选择有效选项',
  'external_skill_field_upload': '请上传有效文件',
  'external_skill_field_max_size': '单个文件不能超过 {size} MB',
  'external_skill_field_accept': '支持格式：{accept}',
  'mixture_of_agents_brief': '自动混合最佳AI模型以完成您的任务。',
  'element_chat': '元素对话',
  'ask_about_element': '询问有关此元素的内容...',
  'version_add_error': '版本异常，无法添加到项目',
  'web_error_regenerate': '重新生成',
  'conversation_not_exist': '对话不存在或已被删除',
  'img_upload_fail': '图片上传失败',
  'no_img_url': '未获取到图片地址',
  'replace_img_success': '图片替换成功',
  'no_element_selected_or_invalid': '未选中任何元素或元素无效',
  'text_cannot_be_empty': '文本不能为空',
  'original_text_cannot_be_empty': '原文本不能为空',
  'cannot_locate_source_file': '无法定位元素源文件',
  'replace_failed_cannot_locate_file': '替换失败：无法定位文件位置',
  'replace_failed': '替换失败：{message}',
  'link_cannot_be_empty': '链接不能为空',
  'cannot_get_original_image_url': '无法获取原图片地址',
  'no_image_selected': '未选择图片',
  'image_size_exceeds_limit': '图片大小不能超过 5MB',
  'image_upload_failed': '图片上传失败',
  'image_processing_failed': '图片处理失败',
  'send_request_failed': '发送请求失败',
  'sources':'来源',
  'file_upload_limit_error':'最多允许上传{filesLength}个文件',
  'copy_image': '复制图片',
  'download_full_size': '下载完整尺寸',
  'edit_image': '引用图片',
  'edit_image_failed': '引用图片失败',
  'download_failed': '下载失败',
  'image_already_added': '该图片已添加',
  'upgrade_subscription_download_code': '升级订阅可下载完整代码',
  'tool_calls_empty': '无工具调用',
  'tool_calls_count': '调用了 {count} 次工具',
  'tool_group_count': '调用了 {count} 次工具',
  'tool_calls_single': '调用了 {tool}',
  'tool_calls_summary': '调用了 {count} 次工具：{summary}',
  'todo_progress_step': '第 {current} / {total} 步',
  'tool_result_empty': '暂无工具结果',
  'tool_status_success': '完成',
  'tool_status_running': '进行中',
  'tool_status_failed': '失败',
  'tool_status_stopped': '已停止',
  'tool_status_warning': '警告',
  'tool_status_pending': '等待中',
  'tool_summary_seconds': '{seconds}s',
  'tool_detail_files_changed': '变更文件',
  'tool_detail_commands': '命令',
  'tool_detail_logs': '执行日志',
  'tool_detail_arguments': '参数',
  'tool_detail_raw_result': '原始结果',
  'tool_detail_template': '框架',
  'tool_detail_project': '项目标题',
  'tool_detail_install_dependencies': '安装依赖',
  'tool_detail_deploy': '部署',
  'tool_detail_version': '版本',
  'tool_detail_source': '来源',
  'tool_detail_response_time': '耗时',
  'tool_detail_continuation': '续写次数',
  'tool_detail_error': '错误',
  'tool_batch_query_count': '{count} 个查询',
  'tool_search_result_count': '{count} 条结果',
  'tool_vertical_domain_count': '{count} 个领域',
  'tool_vertical_capability_count': '{count} 项能力',
  'tool_extract_content_title': '提取内容',
  'clarification_title': '补充确认',
  'clarification_loading_title': '正在梳理需求',
  'clarification_loading_desc': 'PAITEAMS 正在整理问题卡片，请稍候',
  'clarification_progress': '{answered}/{total}',
  'clarification_progress_percent': '{percent}%',
  'clarification_progress_empty': '0/0',
  'clarification_required': '必填',
  'clarification_multi_select': '可多选',
  'clarification_multi_select_suffix': '（选择所有适用项）',
  'clarification_note_placeholder': '补充信息（可选）',
  'clarification_skip': '跳过',
  'clarification_prev': '上一题',
  'clarification_next': '下一步',
  'clarification_submit': '提交',
  'tool_name_ask_clarification': '补充确认',
  'tool_name_ask_user_questions': '需求确认',
  'tool_name_web_search': '网页搜索',
  'tool_name_image_search': '图片搜索',
  'tool_name_image_generation': '图片生成',
  'tool_name_video_script_list': '视频脚本目录',
  'tool_name_video_script_read': '读取视频脚本',
  'tool_name_video_generation_quote': '视频生成报价',
  'tool_name_video_script_save': '编写视频脚本',
  'tool_name_video_generation_execute': '生成视频',
  'tool_name_remove_background': '去除背景',
  'tool_name_web_image_generation': '生成图片',
  'tool_name_web_fetch': '网页抓取',
  'tool_name_read_file': '读取文件',
  'tool_name_load_skill': '加载技能',
  'tool_skill_visual_design': '视觉设计',
  'tool_skill_web_development': '网页开发',
  'tool_reference_design_catalog': '设计规范目录',
  'tool_reference_showcase_catalog': '案例目录',
  'tool_reference_design_guideline': '设计规范',
  'tool_reference_design_example': '设计案例',
  'tool_name_write_file': '写入文件',
  'tool_name_ls': '列出项目',
  'tool_name_bash': '执行命令',
  'tool_name_str_replace': '替换文本',
  'tool_name_write_todos': '任务步骤',
  'tool_name_web_dev_save_project': '项目方案设计',
  'tool_name_web_dev_read_project': '读取项目',
  'tool_name_web_dev_select_template': '技术方案设计',
  'tool_name_web_dev_code_generate': '生成代码',
  'tool_name_web_dev_build': '构建部署',
  'tool_name_batch_search': '批量搜索',
  'tool_name_extract': '阅读内容',
  'tool_name_get_sub_domains': '垂直搜索',
  'tool_name_tool_search': '工具检索',
  'tool_name_tool': '工具',
  'tool_name_query_tool': '查询工具',
  'media_canvas': {
    'title': '画布',
    'open': '打开画布',
    'close': '关闭画布',
    'save': '保存',
    'saving': '保存中',
    'saved': '已保存',
    'unsaved': '未保存',
    'save_failed': '保存失败',
    'version_conflict': '画布版本已更新，请刷新后再保存',
    'version_conflict_title': '文件版本落后',
    'version_conflict_description': '您的文件版本已落后，您可能在其他浏览器标签页中打开了同一项目。请刷新浏览器获取最新版本。',
    'version_conflict_refresh': '刷新',
    'assets': '素材',
    'empty_assets': '暂无素材。上传、粘贴或生成图片后会出现在这里。',
    'video': '视频',
    'video_previews': '视频预览',
    'video_scripts': '视频脚本文档',
    'play_video': '播放视频',
    'pause_video': '暂停视频',
    'video_unavailable': '视频暂时无法播放',
    'unnamed_asset': '未命名素材',
    'upload_asset': '上传素材',
    'close_assets': '收起素材',
    'hide_asset': '隐藏图片',
    'show_asset': '显示图片',
    'add_to_chat': '添加到对话中',
    'edit_image': '改图',
    'text_edit_region_label': '文字段落 {index}',
    'text_edit': '编辑文字',
    'text_edit_rewrite': '修改文字',
    'text_edit_extract': '提取文字',
    'text_edit_erase': '消除文字',
    'text_edit_recognition_in_progress': '原图正在识别，请等待当前识别完成，不要重复发起调用。',
    'text_edit_model_billing_unavailable': '环境默认图片模型的计费配置不可用，请联系管理员；不会自动切换模型。',
    'text_edit_request_conflict': '请求关联信息不一致，请先查询原任务再重试，避免重复生成。',
    'text_edit_regions': '图片识别文字框',
    'text_edit_recognizing': '正在识别文字……',
    'text_edit_verifying_source': '正在核验原图，请稍候……',
    'text_edit_source_verification_unavailable': '原图暂时无法核验，已保留识别结果，请点击重新核验。',
    'text_edit_recheck_source': '重新核验',
    'text_edit_probing_metadata': '正在核验原图尺寸和文件大小……',
    'text_edit_context_unavailable': '当前图片缺少会话信息，暂时无法编辑文字',
    'text_edit_missing_metadata': '缺少原图尺寸或文件大小，请等待核验后重试',
    'text_edit_metadata_failed': '原图信息核验失败，请点击提示或重新选择图片后重试',
    'text_edit_source_timeout': '原图读取超时，请稍后重试。',
    'text_edit_source_unavailable': '原图读取失败，请稍后重试。',
    'text_edit_source_decode_failed': '原图格式或内容无效，请重新上传图片后重试。',
    'text_edit_source_too_large': '文字编辑仅支持原图长边不超过 3840px、短边不超过 2160px，且文件不超过 10MB',
    'text_edit_missing_url': '当前图片缺少有效原图地址',
    'text_edit_unsupported_format': '文字编辑仅支持当前画布已有的 JPG、PNG 和 WEBP 格式',
    'text_edit_no_text': '未识别到文字。',
    'text_edit_select_region': '请点击图片上的一个完整文字框',
    'text_edit_recognized_text': '识别内容（请核对）',
    'text_edit_new_text': '替换文字',
    'text_edit_new_text_placeholder': '输入要替换的新文字',
    'text_edit_rewrite_submit': '应用修改',
    'text_edit_erase_submit': '消除所选文字',
    'text_edit_erase_confirm': '仅消除已选框的文字并修复背景，结果插入旁边，原图不变。',
    'text_edit_generation_hint': '复杂背景下效果可能不稳定；不保证字体、透视、颜色和生成文字完全还原。结果保留原图并插入旁边。',
    'text_edit_copy': '复制文字',
    'text_edit_copied': '文字已复制',
    'text_edit_manual_copy': '请长按或使用快捷键手动复制。',
    'text_edit_recognize_again': '重新识别',
    'text_edit_recognize_again_hint': '重新识别会发起新的 OCR 调用，并按实际调用计费',
    'text_edit_check_status': '查询任务状态',
    'text_edit_checking': '正在查询……',
    'text_edit_check_unconfirmed': '本次查询仍未确认结果；可继续查询，符合条件时可结束等待。',
    'text_edit_query_failed': '查询失败，请检查网络或稍后重试；原任务不会自动重新生成。',
    'text_edit_query_timeout': '查询超时，请稍后重试；这不代表生成失败。',
    'text_edit_query_succeeded': '原任务已完成，已恢复处理结果。',
    'text_edit_last_check': '最近查询 {time}：{status}',
    'text_edit_end_wait': '结束等待',
    'text_edit_end_wait_confirm': '结束本次等待后可手动重新生成，但不保证供应商已取消原请求，新的生成可能另行计费。确定结束等待？',
    'text_edit_wait_ended': '已结束本次等待，可以重新选择文字并手动生成。',
    'text_edit_recovery_action_required': '任务状态查询已暂停，请检查登录或访问权限后重试。',
    'text_edit_multiline_hint': '此框包含多行文字，首版不会自动合并相邻文字框，请核对换行。',
    'text_edit_edge_hint': '目标文字靠近原图边缘，背景上下文有限，生成效果可能下降。',
    'text_edit_vertical_hint': '目标框可能为竖排文字，请核对内容和排版；生成效果可能下降。',
    'text_edit_tilted_hint': '目标文字可能倾斜或带透视，生成效果可能下降。',
    'text_edit_crop_hint': '裁剪范围外或被截断的文字框不可选，请先调整图片裁剪范围。',
    'text_edit_invalid_regions_hint': '部分识别框坐标无效或 ID 重复，已跳过；不会使用错误坐标。',
    'text_edit_invalid_ocr': '识别结果的坐标或关联信息无效，无法安全编辑，请重新识别。',
    'text_edit_empty_text': '内容不能为空；移除文字请使用“消除文字”。',
    'text_edit_same_text': '新文字与原文字相同，无需生成。',
    'text_edit_text_too_long': '内容过长，请缩短后提交。',
    'text_edit_protected_overlap': '此文字框与未选中的文字框重叠，无法单独处理。',
    'text_edit_unsafe_region': '此文字框无法安全处理，请核对识别范围。',
    'text_edit_overlap_conflict': '同一位置的识别框填写了不同内容，无法同时修改。',
    'text_edit_local_input_limit': '原图规格或比例不满足默认生图模型的文字编辑限制。',
    'text_edit_processing': '文字处理任务正在进行，请稍候。',
    'text_edit_submitting': "正在提交…",
    'text_edit_timeout': "图片处理超时，占位已移除，可以重新生成。",
    'text_edit_wait_connection': "等待已结束，正在恢复任务状态；网络恢复后会自动确认是否可以重新生成。",
    'text_edit_busy': '当前有其他请求正在处理，请稍后重试',
    'text_edit_failed': '文字处理失败，请核对后重试',
    'text_edit_generation_failed_retry': '生成失败，请重试',
    'text_edit_unknown': '生成失败，请重试',
    'text_edit_result_unconfirmed': '正在自动确认文字处理结果，请稍候。',
    'text_edit_tool_unavailable': '默认 OCR 工具不可用，请联系管理员。',
    'text_edit_model_unavailable': '环境默认图片模型未配置或不可用，请联系管理员',
    'text_edit_model_unsupported': '默认模型不支持图片编辑，请联系管理员。',
    'text_edit_recognition_expired': '识别已过期，请重新识别。',
    'text_edit_source_changed': '源图或原图尺寸已变化，请重新选择图片并识别',
    'text_edit_recognition_failed': '文字识别暂时失败，请稍后重试',
    'text_edit_recognition_unknown': '文字识别失败，请重试。',
    'text_edit_content_rejected': '当前图片或替换文字未通过内容审核，请调整后重试',
    'text_edit_rate_limited': '文字服务请求过于频繁，请稍后重试',
    'text_edit_points_insufficient': '积分不足，请充值后重试',
    'text_edit_service_unavailable': '文字编辑服务暂不可用，请稍后重试',
    'expand': '扩图',
    'expand_title': '扩图',
    'expand_description': '选择最终画布比例，原图保持比例并居中，不裁剪、不拉伸。',
    'expand_drag_hint': '拖动边缘或角点调整扩展范围',
    'expand_ratio_too_large': '该比例超出单边 5824px 上限，请拖动调整范围',
    'expand_custom': '自定义',
    'expand_width': '宽度',
    'expand_height': '高度',
    'expand_submit': '开始扩图',
    'expand_source_too_large': '原图长边超过 4160 像素，无法扩图',
    'expand_custom_invalid': '请输入 1–5824 的整数尺寸',
    'expand_custom_must_contain': '自定义画布宽高不能小于原图',
    'expand_target_unreachable': '当前尺寸和原图位置无法完成扩图，请调整宽高或原图位置',
    'expand_round_limit': '当前扩图范围超过可完成的轮次，请缩小范围或调整原图位置',
    'expand_no_change': '目标尺寸与原图相同，请扩大扩图范围',
    'expand_failed_retry': '扩图失败，请重新生成',
    'edit_prompt_placeholder': '描述你想如何修改图片',
    'high_definition': '高清',
    'high_definition_output_size': '选择放大倍数和输出尺寸',
    'high_definition_scale': '{scale} 倍',
    'high_definition_preserve_alpha': '透明通道将尽量保留',
    'high_definition_limit_option': '输出任一边不能超过 {max} 像素',
    'high_definition_invalid_selection': '请选择一张已就绪的图片',
    'high_definition_missing_url': '当前图片缺少有效素材地址',
    'high_definition_unsupported_format': '高清仅支持 JPG、PNG 和 WEBP 图片',
    'high_definition_missing_dimensions': '缺少图片原始尺寸，请等待服务端探测后重试',
    'high_definition_probing_dimensions': '正在探测图片原始尺寸',
    'high_definition_limit_reached': '当前图片尺寸已达到服务上限（{max} 像素），无法继续放大',
    'high_definition_failed_retry': '高清处理失败，请重试',
    'high_definition_source_too_large': '图片超过20MB，请压缩后重试',
    'high_definition_status_uncertain': '任务状态暂未确认；再次重试会继续使用原任务',
    'remove_background_prompt': '请去除这张图片的背景，并输出透明背景图片。',
    'remove_background_failed_retry': '去背景失败，请重新生成',
    'eraser': '橡皮擦',
    'eraser_title': '橡皮擦',
    'eraser_description': '涂抹需要消除的区域，生成后原图不会被覆盖。',
    'eraser_brush': '画笔',
    'eraser_mask_eraser': '蒙版橡皮',
    'eraser_brush_size': '笔刷大小',
    'eraser_undo': '撤销',
    'eraser_redo': '重做',
    'eraser_reset': '重置',
    'eraser_mask_hint': '白色区域会被消除，黑色区域会保留。',
    'eraser_submit': '立即生成',
    'eraser_missing_image': '当前图片缺少可编辑地址',
    'eraser_missing_dimensions': '缺少图片原始尺寸，暂时无法使用橡皮擦',
    'eraser_source_too_large': '图片超过橡皮擦可处理范围，请压缩后重试',
    'eraser_bria_source_too_large': '原图超过 30MB，请压缩后重试',
    'eraser_capabilities_unavailable': '橡皮擦配置不可用或未配置默认工具，无法安全确认服务端使用的工具。请检查后端配置并重试',
    'eraser_capabilities_legacy_fallback': '未能读取最新橡皮擦配置，暂按原有限制（2560 × 1440、10 MB）编辑；未切换供应商。BRIA 大图请稍后重试。',
    'eraser_resource_unavailable': '当前浏览器无法处理这张原尺寸图片，请尝试内存更充足的设备（图片未缩放）',
    'eraser_image_load_failed': '图片加载失败，请重试',
    'eraser_mask_export_failed': '蒙版导出失败，请重试',
    'eraser_invalid_input': '蒙版或图片尺寸无效，请修改后重试',
    'eraser_service_unavailable': '橡皮擦服务暂不可用',
    'eraser_rate_limited': '服务繁忙，请稍后重试',
    'eraser_content_rejected': '当前图片或消除区域不符合服务规则',
    'eraser_result_unknown': '结果待确认，请稍后查看任务状态',
    'eraser_failed_retry': '消除失败，请重新生成',
    'untitled': '未命名画布',
    'need_conversation': '请先创建会话后再添加画布素材',
    'upload_missing_url': '上传成功但未返回文件地址',
    'asset_create_failed': '素材创建失败',
    'asset_rename_failed': '素材重命名失败',
    'asset_delete_failed': '删除素材失败，请重试',
    'export': {
      'open': '导出',
      'close': '关闭导出',
      'title': '导出',
      'export_type': '导出类型',
      'image': '图片',
      'format': '图片格式',
      'original_format': '原图格式（自动匹配）',
      'size': '导出尺寸',
      'original_size': '原图尺寸',
      'scale_value': '{scale} 倍',
      'download_range': '下载范围',
      'download_content': '下载内容',
      'download_count': '下载内容 {count}',
      'all_selected_content': '全选图片',
      'max_selected_assets': '单次最多选择 {count} 张图片',
      'selection_limit_reached': '不能超过 {max} 张图片',
      'export_mode': '导出方式',
      'separate': '分开下载',
      'long_image': '拼成一张',
      'separate_detail': '多张图片将分别处理并打包为 ZIP 文件',
      'watermark': 'LOGO',
      'logo_watermark': '平台 LOGO',
      'membership_required': '基础版必选',
      'watermark_position': 'LOGO位置',
      'position_top_left': '左上',
      'position_top_center': '中上',
      'position_top_right': '右上',
      'position_middle_left': '左',
      'position_center': '中',
      'position_middle_right': '右',
      'position_bottom_left': '左下',
      'position_bottom_center': '中下',
      'position_bottom_right': '右下',
      'kicker': '画布导出工作区',
      'asset_hint': '选择图片并逐张调整导出参数',
      'output_settings': '输出设置',
      'output_settings_hint': '格式和倍率应用于本次导出',
      'pixel_width': '主图宽度（像素）',
      'pixel_height': '主图高度（像素）',
      'lock_aspect_ratio': '锁定宽高比',
      'resize_mode': '尺寸方式',
      'resize_mode_exact': '宽高都一致',
      'resize_mode_width': '宽度一致',
      'resize_mode_height': '高度一致',
      'resize_mode_fit': '等比例适应',
      'image_apply_mode': '应用方式',
      'image_properties': '图片属性',
      'image_properties_hint': '每张图片可以单独设置',
      'apply_single': '应用单张',
      'apply_selected_all': '应用已选所有',
      'sync_properties_to_selected_images': '应用到选中图片',
      'apply_image_settings': '同步',
      'sync_logo_to_selected_images': 'LOGO 同步到所有选中图片',
      'apply_image_to_selected': '像素应用到已选',
      'custom_watermark': '用户专属 LOGO',
      'custom_watermark_hint': '可上传专属 LOGO 并拖动调整位置',
      'watermark_image': '图片 LOGO',
      'no_watermark_short': '无 LOGO',
      'no_custom_watermark': '不添加用户专属 LOGO',
      'upload_watermark': '上传 LOGO',
      'uploading_watermark': '上传中',
      'watermark_upload_success': 'LOGO 已添加',
      'watermark_upload_failed': 'LOGO 上传失败，请重试',
      'delete_watermark': '删除 {name}',
      'watermark_delete_title': '确认删除 LOGO',
      'watermark_delete_confirm': '确定要删除“{name}”吗？删除后将无法在导出中使用。',
      'watermark_delete_confirm_button': '删除',
      'watermark_delete_success': 'LOGO 已删除',
      'watermark_delete_failed': 'LOGO 删除失败，请重试',
      'watermark_format_invalid': '仅支持 PNG、JPG、WEBP LOGO',
      'watermark_file_too_large': 'LOGO 文件不能超过 5MB',
      'watermark_rotation': 'LOGO 角度（°）',
      'watermark_opacity': 'LOGO 透明度（%）',
      'drag_watermark': '拖动预览中的 LOGO 调整位置',
      'resize_watermark': '拖动 LOGO 角点调整大小',
      'watermark_position_hint': '快捷定位或拖动预览中的 LOGO',
      'watermark_pixel_settings': 'LOGO 像素',
      'advanced_settings': '高级设置',
      'watermark_pixel_settings_hint': '按导出尺寸精确设置 LOGO 位置和大小',
      'watermark_pixel_x': 'LOGO X（像素）',
      'watermark_pixel_y': 'LOGO Y（像素）',
      'watermark_pixel_width': 'LOGO 宽度（像素）',
      'watermark_pixel_height': 'LOGO 高度（像素）',
      'image_setting_uniform': '图片统一设置',
      'image_setting_individual': '图片单独设置',
      'logo_setting_uniform': 'Logo统一设置',
      'logo_setting_individual': 'Logo单独设置',
      'no_logo': '无Logo',
      'cancel': '取消',
      'submit': '导出',
      'exporting': '导出中',
      'exporting_progress': '导出素材 {current}/{total}',
      'export_progress_estimate': '预计进度',
      'export_progress_preparing': '准备导出',
      'export_progress_rendering': '正在处理素材',
      'export_progress_packaging': '正在整理文件',
      'export_progress_complete': '导出完成',
      'empty_canvas': '素材库中暂无可导出的图片',
      'save_before_export_failed': '保存画布失败，暂时无法导出',
      'export_success': '导出完成',
      'download_url_missing': '导出完成但未返回下载地址，请重试',
      'subscription_required': '升级订阅后可使用画布导出',
      'export_failed': '导出失败，请重试',
      'processing_failed': '导出处理失败，请重试',
      'processing_timeout': '导出处理超过 600 秒，请稍后重试',
      'no_images_selected': '请至少选择一张图片',
      'invalid_export_mode': '导出方式无效，请重新选择',
      'invalid_export_format': '图片格式无效，请重新选择',
      'invalid_export_scale': '导出倍率无效，请重新选择',
      'invalid_export_asset_ids': '导出图片选择无效，请重新选择',
      'invalid_export_asset_mode': '单图仅支持单图导出，多图请选择分开下载或拼成长图',
      'invalid_export_manifest': '导出图片参数无效，请重新设置',
      'invalid_resize_mode': '图片尺寸方式无效，请重新选择',
      'limit_asset_count': '单次最多选择 {max} 张图片',
      'limit_mode_count': '单图导出需要选择 1 张图片，多图导出至少需要选择 2 张图片',
      'limit_long_asset_count': '拼成长图最多选择 {max} 张图片',
      'limit_output_dimension': '输出宽高必须是正整数',
      'limit_output_edge': '每张图片的输出宽高都不能超过 {maxEdge} 像素',
      'limit_per_image_pixels': '每张图片的输出像素不能超过 67,240,000（约 67.24MP，8200 × 8200）',
      'pixel_limit_single': '单图输出：宽、高均≤13,000px，且像素≤67,240,000（约 67.24MP，8200 × 8200）；',
      'limit_source_edge': '源图单边不能超过 {maxSourceEdge} 像素',
      'limit_source_pixels': '源图像素不能超过 67,240,000（约 67.24MP，例如 8,200 × 8,200）',
      'limit_separate_pixels': '分开下载的全部图片输出像素总和不能超过 1,280,000,000（1280MP）',
      'limit_long_pixels': '拼成长图后的画布像素不能超过 67,108,864',
      'limit_source_file_size': '单个源文件不能超过 100MiB',
      'limit_source_total_size': '本次导出的源文件总量不能超过 1,024MiB（1GiB）',
      'pixel_limit_per_image': '分开下载或长图中的每张输出图片：宽、高均≤13,000px，且单张像素≤67,240,000（约 67.24MP，8200 × 8200）；',
      'pixel_limit_separate': '分开下载全部图片合计≤1,280,000,000 像素；',
      'pixel_limit_long': '拼成长图按“最大宽度 × 高度总和”计算，画布≤67,108,864 像素。',
      'scroll_load_more': '继续下滑加载更多图片'
    }
  }
}
